import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Youtube, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  const mainNavLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Programs / Classes',
    href: '/programs'
  }, {
    name: 'Schedule',
    href: '/schedule'
  }, {
    name: 'Instructors',
    href: '/instructors'
  }, {
    name: 'Free Class',
    href: '/free-class'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  const programLinks = [{
    name: 'Brazilian Jiu-Jitsu',
    href: '/programs/brazilian-jiu-jitsu'
  }, {
    name: 'Kids Brazilian Jiu-Jitsu',
    href: '/programs/kids-brazilian-jiu-jitsu'
  }, {
    name: 'Muay Thai',
    href: '/programs/muay-thai'
  }, {
    name: 'Boxing',
    href: '/programs/boxing'
  }, {
    name: 'Kickboxing',
    href: '/programs/kickboxing'
  }, {
    name: 'MMA Training',
    href: '/programs/mma-training'
  }, {
    name: 'Personal Training',
    href: '/programs/personal-training'
  }, {
    name: 'Adopt A Cop',
    href: '/programs'
  }];
  const socialLinks = [{
    name: 'Instagram',
    href: 'https://www.instagram.com/mashgym/',
    icon: Instagram
  }, {
    name: 'Facebook',
    href: 'http://facebook.com/mashgym',
    icon: Facebook
  }, {
    name: 'YouTube',
    href: 'https://www.youtube.com/c/MashGym',
    icon: Youtube
  }];
  return <footer className="bg-[#0f0f0f] text-white" data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-69">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-70">
          {/* Section 1: Gym Information */}
          <div data-id="element-71">
            <h3 className="text-xl font-bold text-white mb-6 uppercase tracking-wide" data-id="element-72">
              Mash Gym
            </h3>
            <div className="space-y-4 text-gray-400" data-id="element-73">
              <div className="flex items-start" data-id="element-74">
                <MapPin className="w-5 h-5 mr-3 flex-shrink-0 mt-0.5 text-red-600" data-id="element-75" />
                <span data-id="element-76">
                  26575 8 Mile Road
                  <br data-id="element-77" />
                  Redford, MI 48240
                </span>
              </div>
              <div className="flex items-center" data-id="element-78">
                <Phone className="w-5 h-5 mr-3 flex-shrink-0 text-red-600" data-id="element-79" />
                <span data-id="element-80">(313) 555-0100</span>
              </div>
              <div className="flex items-center" data-id="element-81">
                <Mail className="w-5 h-5 mr-3 flex-shrink-0 text-red-600" data-id="element-82" />
                <span data-id="element-83">info@mashgym.com</span>
              </div>
            </div>
          </div>

          {/* Section 2: Main Navigation */}
          <div data-id="element-84">
            <h3 className="text-xl font-bold text-white mb-6 uppercase tracking-wide" data-id="element-85">
              Navigation
            </h3>
            <ul className="space-y-3" data-id="element-86">
              {mainNavLinks.map(link => <li key={link.name} data-id="element-87">
                  <Link to={link.href} className="text-gray-400 hover:text-red-600 transition-colors duration-200" data-id="element-88">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Section 3: Programs */}
          <div data-id="element-89">
            <h3 className="text-xl font-bold text-white mb-6 uppercase tracking-wide" data-id="element-90">
              Programs
            </h3>
            <ul className="space-y-3" data-id="element-91">
              {programLinks.map(link => <li key={link.name} data-id="element-92">
                  <Link to={link.href} className="text-gray-400 hover:text-red-600 transition-colors duration-200" data-id="element-93">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Section 4: Social Media */}
          <div data-id="element-94">
            <h3 className="text-xl font-bold text-white mb-6 uppercase tracking-wide" data-id="element-95">
              Follow Us
            </h3>
            <div className="flex space-x-4" data-id="element-96">
              {socialLinks.map(social => {
              const Icon = social.icon;
              return <a key={social.name} href={social.href} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-red-600 rounded-full flex items-center justify-center transition-all duration-300" aria-label={social.name} data-id="element-97">
                    <Icon className="w-5 h-5" data-id="element-98" />
                  </a>;
            })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10" data-id="element-99">
          <p className="text-center text-gray-500 text-sm" data-id="element-100">
            © 2026 Mash Gym. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}